import { forwardRef } from 'react';
import { Calendar } from '@hn-ui/icons';
import { styled } from 'styled-components';

import { PrintButton } from './Common';

const StyledPrintButton = styled(PrintButton)`
  box-shadow: none;
  padding: 10px;
  margin: 0;
  border-radius: 8px;
`;

const DatePickerInput = ({ onClick }, ref) => (
  <StyledPrintButton
    aria-label='Select a date range'
    onClick={onClick}
    ref={ref}
  >
    <Calendar size={20} color='black100' />
  </StyledPrintButton>
);

export default forwardRef(DatePickerInput);
